"use client";

import { cn } from "@/lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { MediaCarouselThumbnails } from "./MediaCarouselThumbnails";

const footerClasses = "flex items-center gap-4 mt-4 pb-4 w-full max-w-full";
const arrowButtonClasses =
  "hidden md:flex items-center justify-center w-8 h-8 rounded-full bg-black/20 backdrop-blur-sm hover:bg-black/30 transition-colors duration-200";

export interface MediaCarouselFooterProps {
  urls: string[];
  selectedIndex: number;
  onSlideSelect: (index: number) => void;
  className?: string;
  fallbackThumbnailUrl?: string;
}

export const MediaCarouselFooter = ({
  urls,
  selectedIndex,
  onSlideSelect,
  className,
  fallbackThumbnailUrl,
}: MediaCarouselFooterProps) => {
  if (!urls || urls.length === 0) {
    return null;
  }

  const totalSlides = urls.length;

  const handlePrevious = () => {
    const previousIndex =
      selectedIndex === 0 ? totalSlides - 1 : selectedIndex - 1;
    onSlideSelect(previousIndex);
  };

  const handleNext = () => {
    const nextIndex = selectedIndex === totalSlides - 1 ? 0 : selectedIndex + 1;
    onSlideSelect(nextIndex);
  };

  return (
    <div className={cn(footerClasses, className)}>
      <button
        type="button"
        onClick={handlePrevious}
        className={cn(arrowButtonClasses)}
        aria-label="Previous slide"
      >
        <ChevronLeft className="w-4 h-4 text-white" />
      </button>

      <div className="flex-1 min-w-0">
        <MediaCarouselThumbnails
          urls={urls}
          selectedIndex={selectedIndex}
          onSlideSelect={onSlideSelect}
          fallbackThumbnailUrl={fallbackThumbnailUrl}
        />
      </div>

      <button
        type="button"
        onClick={handleNext}
        className={cn(arrowButtonClasses)}
        aria-label="Next slide"
      >
        <ChevronRight className="w-4 h-4 text-white" />
      </button>
    </div>
  );
};
